import {
    UPLOAD_DOCUMENTS_RESET,
    UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE,
    UPLOAD_DOCUMENTS_SET_VALID,
    UPLOAD_DOCUMENTS_SET_VALUE,
} from '../../actions/sizotsaFuneralCover/uploadDocuments';
import { FIELD_STATUS, FORM_STATUS } from '../status';

export const initUploadDocument = {
    formStatus: FORM_STATUS.INVALID,
    form: {
        certifiedCopyOfId: { fileName: null, fileContaint: null, error: null, status: null, file: null },
        incomeProof: { fileName: null, fileContaint: null, error: null, status: null, file: null },
        addressProof: { fileName: null, fileContaint: null, error: null, status: null, file: null },
        bankStatement: { fileName: null, fileContaint: null, error: null, status: null, file: null },
    },
};

export default (state = initUploadDocument, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    switch (action.type) {
        case UPLOAD_DOCUMENTS_SET_VALUE:
            const { inputType, fileName, fileContaint, file } = action.value;
            return updateFormField(inputType, (field) => ({
                ...field,
                fileName: fileName,
                fileContaint: fileContaint,
                file: file,
            }));

        case UPLOAD_DOCUMENTS_SET_VALID:
            return updateFormField(action.fileType, (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case UPLOAD_DOCUMENTS_RESET:
            return { ...state, form: initUploadDocument.form };

        case UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE:
            const existingForm = {
                ...state.form,
            };
            action?.value?.forEach((item) => {
                const documentNameKey = item.documentName;
                if (existingForm[documentNameKey]) {
                    existingForm[documentNameKey].url = item.url;
                }
            });
            return { ...state, form: existingForm };

        default:
            return state;
    }
};
